import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom"; // import navigate hook
import Layout from "../../components/Layout";
import apiClient from "../../services/apiClient";
import DynamicTable from "../../components/Table/DataTable";
import { IconEdit, IconEye, IconTrash } from "../../components/icons/icons";

export default function SosPage() {
    const navigate = useNavigate(); // initialize navigate
    const [sosList, setSosList] = useState<any[]>([]);
    const [loading, setLoading] = useState(true);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);

    const fetchSosData = async () => {
        try {
            setLoading(true);
            const response = await apiClient<any>("v1/resource/sosEmergency");
            setSosList(response.data?.sos_emergencies || []);
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchSosData();
    }, []);

    const columns = [
        {
            key: "serial",
            label: "S.No",
            align: "center",
            render: (_row: any, index: number) => page * rowsPerPage + index + 1,
        },
        { key: "name", label: "Name", align: "center", render: (row: any) => row.name },
        { key: "email", label: "Email", align: "center", render: (row: any) => row.email },
        {
            key: "phone_number",
            label: "Phone",
            align: "center",
            render: (row: any) => `${row.isd_code} ${row.phone_number}`,
        },
        {
            key: "type",
            label: "Type",
            align: "center",
            render: (row: any) =>
                row.type ? row.type.charAt(0).toUpperCase() + row.type.slice(1) : "",
        },
        {
            key: "status",
            label: "Status",
            align: "center",
            render: (row: any) => (
                <span
                    style={{
                        padding: "4px 8px",
                        borderRadius: "12px",
                        color: "#fff",
                        backgroundColor: row.status === 1 ? "green" : "red",
                        fontWeight: 500,
                        display: "inline-block",
                        minWidth: "60px",
                        textAlign: "center",
                    }}
                >
                    {row.status === 1 ? "Active" : "Inactive"}
                </span>
            ),
        },
        {
            key: "changes",
            label: "Changes",
            align: "center",
            render: (row: any) => row.additional_info?.Changes || "-",
        },
        {
            key: "location",
            label: "Location",
            align: "center",
            render: (row: any) => row.additional_info?.location || "-",
        },
    ];

    const handleShowDetails = (row: any) => {
        navigate("/sos/add", { state: { sosData: row, mode: "view" } });
    };

    const handleEdit = (row: any) => {
        navigate("/sos/add", { state: { sosData: row, mode: "edit" } });
    };


    const handleDelete = async (row: any) => {
        if (!row.id) return;

        const confirmDelete = window.confirm(`Are you sure you want to delete "${row.name}"?`);
        if (!confirmDelete) return;

        try {
            await apiClient(`/v1/resource/sosEmergency/${row.id}`, {
                method: "DELETE",
            });
            alert("Deleted successfully");
            fetchSosData();
        } catch (error) {
            console.error(error);
            alert("Failed to delete. Please try again.");
        }
    };


    const actions = [
        { label: "View", color: "#2196f3", icon: <IconEye size={20} />, onClick: handleShowDetails },
        { label: "Edit", color: "#4caf50", icon: <IconEdit size={20} />, onClick: handleEdit },
        { label: "Delete", color: "#f44336", icon: <IconTrash size={20} />, onClick: handleDelete },
    ];

    return (
        <Layout>
            <div className="min-h-screen bg-gray-50 p-6">
                <div className="max-w-7xl mx-auto">
                    <div className="flex justify-between items-center mb-4">
                        <div>
                            <h1 className="text-3xl font-bold text-gray-900">SOS Emergencies</h1>
                            <p className="text-gray-600">Active emergency alerts reported by users.</p>
                        </div>
                        <button
                            onClick={() => navigate("/sos/add")}
                            className="
        flex items-center gap-2 
        bg-gradient-to-r from-blue-500 to-blue-700 
        text-white font-semibold 
        px-5 py-2.5 rounded-lg 
        shadow-lg hover:shadow-xl 
        transform hover:-translate-y-0.5 transition-all duration-200
        focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-opacity-50
    "
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                className="h-5 w-5"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                                strokeWidth={2}
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    d="M12 4v16m8-8H4"
                                />
                            </svg>
                            Add SOS
                        </button>

                    </div>

                    <DynamicTable
                        columns={columns}
                        data={sosList}
                        loading={loading}
                        page={page}
                        rowsPerPage={rowsPerPage}
                        totalCount={sosList.length}
                        onPageChange={(newPage) => setPage(newPage)}
                        onRowsPerPageChange={(newRowsPerPage) => {
                            setRowsPerPage(newRowsPerPage);
                            setPage(0);
                        }}
                        emptyMessage="No SOS emergencies found."
                        actions={actions}
                    />
                </div>
            </div>
        </Layout>
    );
}
